import axios from 'axios'

export default {
    get: () => axios.get('fiel'),
    store: (data) => axios.post('fiel/store', data),
    delete: (id) => axios.delete('fiel/'+id)
}